import Login from './login';
import ROLE from './roles';
import STU_TYPE from './stuType';
import { Message } from 'element-ui';
import { cleanCache } from '../api/caches';
import { isRegExp } from './string';
import Time from './time';
import Moment from 'moment';
import Permission from './permission';
import { Codes } from '../api';
let _placeName = '';
const _time = new Time();
/**
 * @desc 会场时间
 * 第一期: 7月17日 0:00-7月25日23:59
 * 第二期：7月31日 0:00 - 8月8日 23:59
 * 第三期：8月14日 0:00 - 8月22日 23:59
 */
export const PLACE_NAME_TIME = {
  SESSION1: {
    start: '2022-07-17 00:00:00',
    end: '2022-07-25 23:59:59'
  },
  SESSION2: {
    start: '2022-07-29 23:00:00',
    end: '2022-08-08 23:59:59'
  },
  SESSION3: {
    start: '2022-08-13 08:00:00',
    end: '2022-08-22 23:59:59'
  }
};
export default class {
  constructor(router) {
    this.$router = router;
    // 此处跳转不再依赖路由name，直接跳转url
    // 原有的name保留只是为了方便对照路由表
    this.routes = {
      home: {
        name: 'Home',
        url: '/'
      },
      info: {
        name: 'info',
        url: '/info'
      },
      stuApply: {
        name: 'student-apply',
        url: '/student/apply'
      },
      volApply: {
        name: 'volunteer-application',
        url: '/volunteer/application'
      },
      stuApply2: {
        name: 'student-apply',
        url: '/student/apply'
      },
      stuApply3: {
        name: 'student-apply',
        url: '/student/apply'
      },
      payApply: {
        name: 'student-apply',
        url: '/student/apply'
      },
      // offer 状态 页面
      offerLetter: {
        name: 'stu-admission',
        url: '/student/admission'
      },
      // 费用支付页面
      tuitionPay: {
        name: 'stu-admission',
        url: '/student/admission'
      },
      // 支付成功页面
      tuitionPaySuccess: {
        name: 'stu-admission',
        url: '/student/admission'
      },
      volunteerAdmission: {
        name: 'volunteer-application',
        url: '/volunteer/application'
      }
    };
    this.permission = Permission;
  }
  locationReplace(href) {
    if (history.replaceState) {
      history.replaceState({}, '', href);
      location.reload();
    } else {
      location.replace(href);
    }
  }
  routeTo = route => {
    if (route.url) {
      let href = window.location.href;
      if (href.indexOf(route.url) < 0) {
        this.locationReplace(route.url);
      }
    } else {
      if (this.$router) {
        this.$router.push(route);
      } else {
        let pathName = window.location.pathname;
        if (pathName !== route.path) {
          this.locationReplace(route.path);
        }
      }
    }
  };
  studentAdmissionRedirection = status => {
    let is_tuition_paid = status.is_tuition_paid; // 是否支付费用
    // 用户 是否能够去付款
    // is_tuition_paid= false 未付费用 并 offer_letter = true 跳付费用
    // offer_letter = null 不操作 进 学生 申请流程
    // offer_letter false 没有操作 进 offer 状态页面
    if (status.offer_letter !== null) {
      // 已付费 去支付成功页面
      if (is_tuition_paid) {
        this.routeTo(this.routes.tuitionPaySuccess);
      }
      // 未付费 已确认 去付费
      if (status.offer_letter && !is_tuition_paid) {
        this.routeTo(this.routes.tuitionPay);
      }
      // 用户 尚未操作 进offer 状态页面
      if (!status.offer_letter) {
        this.routeTo(this.routes.offerLetter);
      }
      return;
    }
  };
  volunteerAdmissionRedirection = status => {
    // let is_tuition_paid = status.is_tuition_paid; // 是否支付费用
    // 用户 是否能够去付款
    // is_tuition_paid= false 未付费用 并 offer_letter = true 跳付费用
    // offer_letter = null 不操作 进 学生 申请流程
    // offer_letter false 没有操作 进 offer 状态页面
    if (status.offer_letter !== null) {
      this.routeTo(this.routes.volunteerAdmission);
      return;
    }
  };
  studentRedirectLogic = status => {
    if (!status?.activate_status_v5?.info_completed) {
      this.routeTo(this.routes.info);
    } else if (status.offer_letter !== null) {
      this.studentAdmissionRedirection(status);
    } else if (!status?.apply_v5?.step1_submitted) {
      this.routeTo(this.routes.stuApply);
    } else if (!(status?.activate_status_v5?.apply_paid || status.is_tuition_paid)) {
      this.routeTo(this.routes.payApply);
    } else if (!status?.apply_v5?.step2_submitted) {
      this.routeTo(this.routes.stuApply2);
    }
    // else if (!status.is_step3_applied) {
    //   this.routeTo(this.routes.stuApply3);
    // }
    else if (status?.apply_v5?.step2_submitted) {
      this.routeTo(this.routes.payApply);
    }
  };
  volunteerRedirectLogic = status => {
    if (!status?.activate_status_v5?.info_completed) {
      this.routeTo(this.routes.info);
    } else if (status.offer_letter !== null) {
      this.volunteerAdmissionRedirection(status);
    } else if (!status?.apply_v5?.step1_submitted) {
      this.routeTo(this.routes.volApply);
    } else if (status?.apply_v5?.step1_submitted) {
      this.routeTo(this.routes.volApply);
    }
    // else if (!status?.apply_v5?.step1_submitted) {
    //   this.routeTo(this.routes.home);
    // } else if (status?.apply_v5?.step1_submitted) {
    //   this.routeTo(this.routes.volApply);
    // }
  };
  initPaidRedirect = async () => {
    let status = await Login.getStatusData(ROLE.STUDENT);
    this._admissionPaidRedirect(status);
  };
  stuAdmissionPaidRedirect = async () => {
    cleanCache();
    let status = await Login.getStatusData(ROLE.STUDENT);
    this._admissionPaidRedirect(status);
  };
  _admissionPaidRedirect = status => {
    if (status) {
      let is_tuition_paid = status.is_tuition_paid; // 是否支付费用
      let offer_letter = status.offer_letter; // 录取
      if (!is_tuition_paid || !offer_letter) {
        Message.error('无访问权限！');
        setTimeout(() => {
          this._stuStatusRedirect(status);
        }, 1000);
      }
    } else {
      Message.error('无访问权限！');
      setTimeout(() => {
        Login.redirectToLogin();
      }, 1000);
    }
  };
  /** 返回会场结果 */
  placeNameResult = async () => {
    return await this.permission.placeNameResult();
  };
  seminarRedirect = () => {
    return new Promise((resolve, reject) => {
      Promise.all([this.permission.hasPlaceResult(), this.permission.isAllowCourseCart(), this.permission.isSeminarOpen()])
        .then(res => {
          resolve();
        })
        .catch(ex => {
          Message.error(ex.msg);
          setTimeout(() => {
            if (ex.status === Codes.AUTH_ERR) {
              Login.redirectToLogin();
            } else {
              this._stuStatusRedirect(this.permission.status);
            }
          }, 1000);
        });
    });
  };
  _stuStatusRedirect = status => {
    console.log('_stuStatusRedirect', status);
    let isLogin = Login.isLogin();
    if (isLogin && status) {
      // 用户 身份 类型  1 学生 3 SSI  / 4 志愿者 8 管培生 12 志愿者+ 管培生
      let active_type = status?.activate_status_v5?.active_type;
      // 用户 申请表单 状态 跳转页面nn
      switch (active_type) {
        case STU_TYPE.STUDENT: {
          // 学生跳转逻辑
          this.studentRedirectLogic(status);
          break;
        }
        case STU_TYPE.SSI: {
          this.studentAdmissionRedirection(status);
          // 学生跳转逻辑
          this.studentRedirectLogic(status);
          break;
        }
        default: {
          // 志愿者 | 实习生 | 志愿者+实习生 跳转逻辑
          this.volunteerRedirectLogic(status);
          break;
        }
      }
    } else {
      Login.redirectToLogin();
    }
  };
  initStuRedirect = async () => {
    let status = await this._getStuStatusData();
    this._stuStatusRedirect(status);
  };
  stuStatusRedirect = async () => {
    let status = await this._getStuStatusData(true);
    this._stuStatusRedirect(status);
  };

  /**
   * 与顶部用户菜单「My HSYLC」一致的站内跳转（按当前登录身份分流）。
   * 学生走 `stuStatusRedirect`，其它角色由本实例 `$router.push`。
   */
  redirectToMyHsylc = () => {
    const loginData = Login.lastLoginData;
    const userType = Login.lastRole;
    if (loginData?.is_dl) {
      if (window.location.pathname !== '/deans-list') {
        this.$router.push({
          name: 'deans-list'
        });
      }
    } else if (loginData && userType === ROLE.STUDENT) {
      this.stuStatusRedirect();
    } else if (loginData && userType === ROLE.SCHOOL) {
      this.$router.push({
        name: 'school-studentApply'
      });
    } else if (loginData && userType === ROLE.SL) {
      this.$router.push({
        name: 'sl-application'
      });
    } else if (loginData && userType === ROLE.TEACHER) {
      this.$router.push({
        name: 'dashboard'
      });
    }
  };

  /**
   * @function getCurrentPlaceName
   * @desc 获取当前时间属于第几期
   */
  getCurrentPlaceName = () => {
    if (_placeName) {
      return _placeName;
    } else if (_time.isBetweenDate(PLACE_NAME_TIME.SESSION1.start, PLACE_NAME_TIME.SESSION1.end)) {
      _placeName = '第一期';
    } else if (_time.isBetweenDate(PLACE_NAME_TIME.SESSION2.start, PLACE_NAME_TIME.SESSION2.end)) {
      _placeName = '第二期';
    } else if (_time.isBetweenDate(PLACE_NAME_TIME.SESSION3.start, PLACE_NAME_TIME.SESSION3.end)) {
      _placeName = '第三期';
    }
    return _placeName;
  };
  /**
   * @function isPlaceNameFinish
   * @desc 判断当前会场是否已经结束
   */
  isPlaceNameFinish = async () => {
    const status = await Login.getStatusData(ROLE.STUDENT, true);
    const placeName = status.place_track.place_name;
    return this._isPlaceNameFinish(placeName);
  };
  /**
   * @function _isPlaceNameFinish
   * @param { String } placeName 期数
   * @desc 判断当前会场是否已经结束
   */
  _isPlaceNameFinish = placeName => {
    if (placeName === '第一期') {
      return _time.isOverDate(PLACE_NAME_TIME.SESSION1.end);
    } else if (placeName === '第二期') {
      return _time.isOverDate(PLACE_NAME_TIME.SESSION2.end);
    } else if (placeName === '第三期') {
      return _time.isOverDate(PLACE_NAME_TIME.SESSION3.end);
    }
  };
  _getStuStatusData = async needNew => {
    if (needNew) {
      cleanCache();
    }
    let status = await Login.getStatusData(ROLE.STUDENT, true);
    // console.log('用户状态:', status);
    return status;
  };
  isPermitted = async arr => {
    let status = await Login.getStatusData(ROLE.STUDENT);
    return this._isPermitted(arr, status);
  };
  _isPermitted = async (arr, status) => {
    let errors = [];
    arr.forEach(item => {
      let value;
      if (item.key === 'professional_track') {
        value = status?.place_track?.professional_track;
      } else if (item.key === 'place_name') {
        value = status?.place_track?.place_name;
      } else {
        value = status?.[item.key];
      }
      if (isRegExp(item.value)) {
        if (!item.value.test(value)) {
          errors.push(item.key);
        }
      } else if (item.key === 'sbp_offer') {
        if ((status?.user_tags || []).indexOf('2022-sbp-offer') < 0) {
          errors.push(item.key);
        }
      } else if (item.value !== value) {
        errors.push(item.key);
      }
    });
    if (localStorage.getItem('whosyourdaddy')) {
      errors = [];
    }
    return !errors.length;
  };
  _minusPermission = status => {
    if (!status) {
      let href = window.location.pathname + encodeURIComponent(window.location.search);
      let path = '/login';
      window.location.href = `${path}?r=${href}`;
      return;
    } else {
      return new Promise(resolve => {
        this._isPermitted(
          [
            { key: 'professional_track', value: 'H-' },
            {
              key: 'place_name',
              value: this.getCurrentPlaceName()
            }
          ],
          status
        ).then(res => {
          if (res) {
            resolve();
          } else {
            Message.error('当前会场H-用户方可进入');
            window.location = '/';
          }
        });
      });
    }
  };
  minusPermission = async () => {
    let status = await Login.getStatusData(ROLE.STUDENT);
    return this._minusPermission(status);
  };
  _placeNamePermission = async status => {
    if (!status) {
      let href = window.location.pathname + encodeURIComponent(window.location.search);
      let path = '/login';
      window.location.href = `${path}?r=${href}`;
      return;
    } else {
      return new Promise(resolve => {
        this._isPermitted(
          [
            {
              key: 'place_name',
              value: /第一期|第二期|第三期/
            }
          ],
          status
        ).then(res => {
          if (res) {
            resolve();
          } else {
            Message.error('无权限访问！');
            window.location = '/';
          }
        });
      });
    }
  };
  placeNamePermission = async () => {
    let status = await Login.getStatusData(ROLE.STUDENT);
    return this._placeNamePermission(status);
  };
  isLimitedPaidPermission = async () => {
    let status = await Login.getStatusData(ROLE.STUDENT);
    if (!this._isLimitedPaid(status)) {
      Message.error('录取后3天内支付才可解锁此内容');
      window.location = '/student/admission';
    }
  };
  _isLimitedPaid = status => {
    let ret = false;
    let paidTime = status.tuition_paid_at;
    let offerTime = status.offer_created_at;
    if (!paidTime) {
      ret = false;
    } else if (_time.isOverDate(paidTime, '2023-04-21 00:00:00')) {
      ret = true;
    } else if (_time.isBetweenDate(offerTime, Moment(offerTime).add(3, 'd'), paidTime)) {
      ret = true;
    }
    return ret;
  };
  /**
   * @description 峰会学生端内页拦截（含跳转）
   * @returns {Promise} resolve - 全县正确时的回调
   * - 峰会开始第一天的凌晨进行切换，每个会场状态切换的时间点不同
   * - 北京：8月13日 23:59
   * - 杭州：8月13日 23:59
   * - 上海：8月11日 23:59
   *  所有峰会中内页，路由拦截
   * 1. 登录
   * 2. 付费
   * - 未付费用户访问，toast提示：“无访问权限！”
   * 3. 会场开始
   * - 会场未开始的情况下，toast提示：“暂未开放”
   */
  hsylcArenaPermission = () => {
    return new Promise((resolve, reject) => {
      Promise.all([this.permission.isAdmissionPaid()])
        .then(res => {
          resolve();
        })
        .catch(ex => {
          Message.error(ex.msg);
          setTimeout(() => {
            if (ex.status === Codes.AUTH_ERR) {
              Login.redirectToLogin();
            } else {
              this._stuStatusRedirect(this.permission.status);
            }
          }, 1000);
        });
    });
  };
  hsylcFormalPermission = () => {
    return new Promise(resolve => {
      Promise.all([this.permission.isAdmissionPaid(), this.permission.isHsylcStart()])
        .then(res => {
          resolve();
        })
        .catch(ex => {
          Message.error(ex.msg);
          setTimeout(() => {
            if (ex.status === Codes.AUTH_ERR) {
              Login.redirectToLogin();
            } else {
              // this._stuStatusRedirect(this.permission.status);
            }
          }, 1000);
        });
    });
  };
  isHsylcStart = () => {
    return new Promise(resolve => {
      this.permission
        .isHsylcStart()
        .then(res => {
          resolve(true);
        })
        .catch(ex => {
          resolve(false);
        });
    });
  };
  isHsylcEnd = () => {
    return new Promise(resolve => {
      this.permission
        .isHsylcEnd()
        .then(res => {
          resolve(true);
        })
        .catch(ex => {
          resolve(false);
        });
    });
  };
  HXWeekOfferPermission = () => {
    let isLogin = Login.isLogin();
    if (!isLogin) {
      Login.redirectToLogin();
      return;
    }
    return new Promise(resolve => {
      this.permission
        .hasHXWeekOffer()
        .then(res => {
          resolve(true);
        })
        .catch(ex => {
          Message.error('仅录取用户可访问');
          setTimeout(() => {
            window.location.href = '/';
          }, 500);
          resolve(false);
        });
    });
  };
  HXWeekPaidPermission = () => {
    let isLogin = Login.isLogin();
    if (!isLogin) {
      Login.redirectToLogin();
      return;
    }
    return new Promise(resolve => {
      this.permission
        .isHXWeekPaid()
        .then(res => {
          resolve(true);
        })
        .catch(ex => {
          Message.error('完成定金支付后，方可访问');
          setTimeout(() => {
            window.location.href = '/';
          }, 500);
          resolve(false);
        });
    });
  };
}
